<template>
  <div class="bg relative h-full min-h-screen" :style="{ backgroundImage: 'url(' + require('@/assets/godzila.jpg') + ')' }">>
    

    <div class="p-10" style="max-width: 1200px; margin: auto;">
      <router-view />
    </div>

    <div class="pt-10"></div>
    <TheNavBar />
  </div>

  
</template>

<script>
import TheNavBar from '@/components/TheNavBar';
import TheFooter from '@/components/gem-farm/TheFooter';
import TheCat from '@/components/gem-farm/TheCat';
export default {
  components: { TheCat, TheFooter, TheNavBar },
};
</script>

<style>

input[type='radio']:checked + span {
  @apply text-black;
}

.bg {
  background-image: url('/assets/godzila.jpg');
}

</style>
